// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { FormHelperText, Stack, Typography } from '@mui/material';

//
import Editor, { Props as EditorProps } from '../editor';

// ----------------------------------------------------------------------

interface Props extends EditorProps {
  name: string;
  label: string;
  leftTitleIcon?: JSX.Element;
}

export default function RHFEditor({ name, label, leftTitleIcon, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Stack spacing={1}>
      <Stack spacing={1} direction="row">
        {!!leftTitleIcon && leftTitleIcon}
        <Typography variant="body1" fontWeight="bold">
          {label}
        </Typography>
      </Stack>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Editor
            id={name.split('.')[0]}
            value={field.value}
            onChange={field.onChange}
            error={!!error}
            helperText={
              <FormHelperText error sx={{ px: 2, textTransform: 'capitalize' }}>
                {error?.message}
              </FormHelperText>
            }
            {...other}
          />
        )}
      />
    </Stack>
  );
}
